import { useState, useEffect, useMemo, useCallback } from 'react';
import { getFormValues } from 'redux-form';
import { useWatch } from 'react-hook-form';
import { useFormAdapter } from '../context/FormAdapterContext';
import { FORM_ADAPTER_TYPES } from '../constants';
import { getNestedValue } from '../utils';
export function useFormFields(fieldNameOrNames) {
  const {
    type,
    store,
    formName
  } = useFormAdapter();
  const isRedux = type === FORM_ADAPTER_TYPES.REDUX;
  const isMultiple = Array.isArray(fieldNameOrNames);
  const fieldNames = useMemo(() => isMultiple ? fieldNameOrNames : [fieldNameOrNames], [isMultiple, fieldNameOrNames]);
  const readReduxValues = useCallback(() => {
    var _ref;
    if (!isRedux || !store) {
      return {};
    }
    return (_ref = getFormValues(formName)(store.getState())) !== null && _ref !== void 0 ? _ref : {};
  }, [isRedux, store, formName]);
  const [reduxValues, setReduxValues] = useState(readReduxValues);
  useEffect(() => {
    if (!isRedux || !store) {
      return undefined;
    }
    const unsubscribe = store.subscribe(() => {
      const latest = readReduxValues();
      setReduxValues(prev => {
        const hasChanged = fieldNames.some(name => getNestedValue(prev, name) !== getNestedValue(latest, name));
        return hasChanged ? latest : prev;
      });
    });
    return unsubscribe;
  }, [isRedux, store, fieldNames, readReduxValues]);
  const rhfFieldValues = useWatch({
    name: fieldNames,
    disabled: isRedux
  });
  const rhfValues = useWatch({
    disabled: isRedux
  });
  if (isRedux) {
    const value = isMultiple ? fieldNames.map(name => getNestedValue(reduxValues, name)) : getNestedValue(reduxValues, fieldNames[0]);
    return {
      value,
      values: reduxValues
    };
  }
  const value = isMultiple ? rhfFieldValues : rhfFieldValues[0];
  return {
    value,
    values: rhfValues
  };
}
//# sourceMappingURL=useFormFields.js.map